import { render, staticRenderFns } from "./dropZone.vue?vue&type=template&id=39410a89"
import script from "./dropZone.vue?vue&type=script&lang=js"
export * from "./dropZone.vue?vue&type=script&lang=js"
import style0 from "./dropZone.vue?vue&type=style&index=0&id=39410a89&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports